import React from 'react';
import { keyframes } from '@emotion/react';
import { Flex, Avatar, Box } from '@chakra-ui/react';
import TwygsLogoIcon from '../../../../assets/twyg-logo-icon.svg';

const wave = keyframes`
  0% { transform: translateY(0); opacity: 0.6; }
  20% { transform: translateY(-4px); opacity: 1; }
  40% { transform: translateY(0); opacity: 0.6; }
  100% { transform: translateY(0); opacity: 0.6; }
`;

const LoadingDots: React.FC = () => (
  <Flex align="center" gap={3}>
    <Avatar src={TwygsLogoIcon} size="sm" bg="green.50" />
    <Box display="flex" alignItems="center">
      <Box display="flex" alignItems="center" bg="white" px={3} py={3} borderRadius="2xl" gap={1}>
        <Box
          as="span"
          bg="gray.600"
          w="7px"
          h="7px"
          borderRadius="full"
          display="inline-block"
          sx={{ animation: `${wave} 1s infinite ease-in-out`, animationDelay: '0s' }}
        />

        <Box
          as="span"
          bg="gray.600"
          w="7px"
          h="7px"
          borderRadius="full"
          display="inline-block"
          sx={{ animation: `${wave} 1s infinite ease-in-out`, animationDelay: '0.15s' }}
        />

        <Box
          as="span"
          bg="gray.600"
          w="7px"
          h="7px"
          borderRadius="full"
          display="inline-block"
          sx={{ animation: `${wave} 1s infinite ease-in-out`, animationDelay: '0.3s' }}
        />
      </Box>
    </Box>
  </Flex>
);

export default LoadingDots;
